import CircularProgressbar from 'react-circular-progressbar'
import './index.scss'

export default CircularProgressbar



// WEBPACK FOOTER //
// ./src/elements/circular-progress-bar/index.js